const labels = {
  All: { 'See the offering': 'ดูข้อเสนอ' },
  FacilityDetails: { 'Ref: Page title': 'รายละเอียดสิ่งอำนวยความสะดวก', 'Ref: Review': 'ทบทวน' },
  FacilitiesList: { 'Ref: Page title': 'สิ่งอำนวยความสะดวก', 'Ref: See details': 'ดูรายละเอียด' },
};
export default labels;
